export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "tooltip": {
          "accessBlocked": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Access to courses has been blocked by the administrator."])},
          "courseNotPublished": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Course page is not published."])}
        },
        "course": {
          "completed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Course completed"])},
          "progress": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["completed"])},
          "free": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Free"])},
          "freePlanAvailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Free plan available"])},
          "availableForPurchase": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Available for purchase"])},
          "goToCourse": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go to course"])},
          "continueLearning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Continue learning"])},
          "learnMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Learn more"])}
        }
      },
      "ru": {
        "tooltip": {
          "accessBlocked": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Доступ к курсам заблокирован администратором."])},
          "courseNotPublished": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Страница курса не опубликована."])}
        },
        "course": {
          "completed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Курс пройден"])},
          "progress": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["пройдено"])},
          "free": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Бесплатно"])},
          "freePlanAvailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Доступен бесплатный тариф"])},
          "availableForPurchase": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Доступен для покупки"])},
          "goToCourse": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Перейти к курсу"])},
          "continueLearning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Продолжить обучение"])},
          "learnMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Узнать больше"])}
        }
      },
      "es": {
        "tooltip": {
          "accessBlocked": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acceso a los cursos bloqueado por el administrador."])},
          "courseNotPublished": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La página del curso no está publicada."])}
        },
        "course": {
          "completed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Curso completado"])},
          "progress": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Completado"])},
          "free": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gratis"])},
          "freePlanAvailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Plan gratuito disponible"])},
          "availableForPurchase": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Disponible para compra"])},
          "goToCourse": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ir al curso"])},
          "continueLearning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Continuar aprendiendo"])},
          "learnMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Más información"])}
        }
      },
      "kk": {
        "tooltip": {
          "accessBlocked": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Курстарға қол жеткізу әкімші тарапынан бұғатталды."])},
          "courseNotPublished": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Курс беті жарияланбаған."])}
        },
        "course": {
          "completed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Курс аяқталды"])},
          "progress": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["аяқталды"])},
          "free": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Тегін"])},
          "freePlanAvailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Тегін тариф қол жетімді"])},
          "availableForPurchase": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сатып алуға қол жетімді"])},
          "goToCourse": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Курсқа өту"])},
          "continueLearning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Оқуды жалғастыру"])},
          "learnMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Толығырақ білу"])}
        }
      },
      "uz": {
        "tooltip": {
          "accessBlocked": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kurslarga kirish administrator tomonidan bloklangan."])},
          "courseNotPublished": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kurs sahifasi nashr etilmagan."])}
        },
        "course": {
          "completed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kurs tugatildi"])},
          "progress": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tamomlanish"])},
          "free": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bepul"])},
          "freePlanAvailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bepul tarif mavjud"])},
          "availableForPurchase": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sotib olish uchun mavjud"])},
          "goToCourse": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kursga o'tish"])},
          "continueLearning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ta'limni davom ettirish"])},
          "learnMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ko'proq ma'lumot olish"])}
        }
      },
      "de": {
        "tooltip": {
          "accessBlocked": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Zugriff auf die Kurse wurde vom Administrator blockiert."])},
          "courseNotPublished": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Die Kursseite ist nicht veröffentlicht."])}
        },
        "course": {
          "completed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kurs abgeschlossen"])},
          "progress": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["abgeschlossen"])},
          "free": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kostenlos"])},
          "freePlanAvailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kostenloser Tarif verfügbar"])},
          "availableForPurchase": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zum Kauf verfügbar"])},
          "goToCourse": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zum Kurs gehen"])},
          "continueLearning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lernen fortsetzen"])},
          "learnMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mehr erfahren"])}
        }
      },
      "fr": {
        "tooltip": {
          "accessBlocked": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L'accès aux cours est bloqué par l'administrateur."])},
          "courseNotPublished": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La page du cours n'est pas publiée."])}
        },
        "course": {
          "completed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cours terminé"])},
          "progress": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Progression"])},
          "free": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gratuit"])},
          "freePlanAvailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Plan gratuit disponible"])},
          "availableForPurchase": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Disponible à l'achat"])},
          "goToCourse": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Accéder au cours"])},
          "continueLearning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Continuer l'apprentissage"])},
          "learnMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["En savoir plus"])}
        }
      },
      "it": {
        "tooltip": {
          "accessBlocked": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L'accesso ai corsi è stato bloccato dall'amministratore."])},
          "courseNotPublished": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La pagina del corso non è stata pubblicata."])}
        },
        "course": {
          "completed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Corso completato"])},
          "progress": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Completato"])},
          "free": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gratuito"])},
          "freePlanAvailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Piano gratuito disponibile"])},
          "availableForPurchase": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Disponibile per l'acquisto"])},
          "goToCourse": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vai al corso"])},
          "continueLearning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Continua l'apprendimento"])},
          "learnMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scopri di più"])}
        }
      }
    }
  })
}
